import { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader } from '../ui/card';
import eau from '../../images/lavage.png';
import robinet from '../../images/robinet (2).png';
import check from '../../images/icons/check.png';
import interdit from '../../images/icons/interdit.png';
import xrobinet from '../../images/xrobinet.png';
import compteur1 from '../../images/compteur1.png';
import compteur2 from '../../images/compteur2.png';
import machine from '../../images/machine.png';
import guide from '../../images/guide.png';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

const GemapiPratique = () => {
  const [toggle, setToggle] = useState('Eau');

  return (
    <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
      <h1 className="text-xl font-bold text-center text-black">Bonnes Pratiques</h1>
      <p className="mt-2 text-base text-center text-black">
        Découvrez nos conseils pour une gestion responsable de l'eau et comprenez vos droits et
        obligations en tant que riverain.
      </p>
      <div className="flex items-center justify-center mt-6 sm:mt-8">
        <div className="flex items-center justify-center gap-4 sm:gap-6">
          <p
            onClick={() => setToggle('Eau')}
            className={`text-base cursor-pointer ${
              toggle === 'Eau' ? 'underline decoration-primary font-bold' : ''
            }`}
          >
            L’usage de l’eau
          </p>
          <p
            onClick={() => setToggle('Guide')}
            className={`text-base cursor-pointer ${
              toggle === 'Guide' ? 'underline decoration-primary font-bold' : ''
            }`}
          >
            Guide du riverain
          </p>
        </div>
      </div>

      {toggle === 'Eau' ? (
        <div id="toggle">
          <Card className="w-full mt-6 sm:mt-8 bg-[#0E6952]">
            <CardHeader className="p-4 sm:p-6">
              <h2 className="text-xl font-bold text-white">L'eau à la maison</h2>
              <p className="font-bold text-[#74FFDA] text-base">150 litres</p>
              <p className="text-base text-white">
                d'eau par jour et par personne en moyenne en France
              </p>
            </CardHeader>
            <CardContent>
              <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
                <div className="w-full space-y-4 md:w-1/2 sm:space-y-6">
                  <div className="p-4 sm:p-6 text-white rounded-lg bg-[#267863]">
                    <h3 className="mb-4 text-base font-medium text-white">
                      Plus de la moitié de cet usage quotidien est réservé :
                    </h3>
                    <div className="space-y-4">
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Toilettes (bain / douche)</span>
                          <span className="text-base font-bold text-[#74FFDA]">39%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '39%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-6 text-white rounded-lg bg-[#267863]">
                    <h3 className="mb-4 text-base font-medium text-white">
                      Le reste se répartit entre :
                    </h3>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Linge</span>
                          <span className="text-base font-bold text-[#74FFDA]">12%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '12%' }}
                          />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Vaisselle</span>
                          <span className="text-base font-bold text-[#74FFDA]">10%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '10%' }}
                          />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Cuisine</span>
                          <span className="text-base font-bold text-[#74FFDA]">6%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '6%' }}
                          />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Ménage (jardin)</span>
                          <span className="text-base font-bold text-[#74FFDA]">6%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '6%' }}
                          />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Voiture</span>
                          <span className="text-base font-bold text-[#74FFDA]">6%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '6%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-6 text-white rounded-lg bg-[#267863]">
                    <h3 className="mb-4 text-base font-medium text-white">Seulement :</h3>
                    <div className="space-y-4">
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-base font-medium">Boisson</span>
                          <span className="text-base font-bold text-[#74FFDA]">1%</span>
                        </div>
                        <div className="w-full h-2 bg-white rounded-full">
                          <div
                            className="bg-[#74FFDA] h-2 rounded-full transition-all duration-500 ease-out"
                            style={{ width: '1%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <img src={eau} alt="Water usage at home" className="w-full h-auto rounded-lg" />
                </div>
              </div>
            </CardContent>
            <CardFooter></CardFooter>
          </Card>

          <div className="mt-6 text-base text-center text-black sm:mt-8">
            Comme cette eau est précieuse, il ne faut pas la gaspiller ni la polluer avec des
            substances (solvants, peintures, médicaments…) qui risqueraient de perturber le cycle de
            dépollution. Les eaux usées sont comme un déchet qu’il faut trier avant de les jeter
            dans les canalisations ! Pour éviter le gaspillage :
          </div>

          <div className="mt-6 sm:mt-8">
            <h2 className="text-xl font-bold text-black">Sachez qu’il vaut mieux prendre :</h2>
            <div className="flex flex-col justify-between gap-6 mt-4 md:flex-row sm:mt-6">
              <div className="w-full md:w-1/2">
                <img src={robinet} alt="Shower faucet" className="w-full h-auto rounded-lg" />
              </div>
              <div className="flex flex-col justify-between w-full gap-4 md:w-1/2 sm:gap-6">
                <Card className="flex flex-col items-center justify-center p-4 sm:p-6 bg-[#E8F5F1]">
                  <CardHeader className="flex items-center justify-center">
                    <CardDescription className="flex items-center justify-center">
                      <div
                        className="w-12 h-12 sm:w-16 sm:h-16 bg-primary"
                        style={{
                          mask: `url(${check}) no-repeat center`,
                          maskSize: 'contain',
                          WebkitMask: `url(${check}) no-repeat center`,
                          WebkitMaskSize: 'contain',
                        }}
                      />
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="text-center">
                    <p className="text-base font-bold">Une douche</p>
                  </CardContent>
                  <CardFooter className="text-center">
                    <p className="text-base font-bold text-primary">60 à 80 litres</p>
                  </CardFooter>
                </Card>
                <Card className="flex flex-col items-center justify-center p-4 sm:p-6 bg-[#E8F5F1]">
                  <CardHeader className="flex items-center justify-center">
                    <CardDescription className="flex items-center justify-center">
                      <div
                        className="w-12 h-12 sm:w-16 sm:h-16 bg-primary"
                        style={{
                          mask: `url(${interdit}) no-repeat center`,
                          maskSize: 'contain',
                          WebkitMask: `url(${interdit}) no-repeat center`,
                          WebkitMaskSize: 'contain',
                        }}
                      />
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="text-center">
                    <p className="text-base font-bold">Qu’un bain</p>
                  </CardContent>
                  <CardFooter className="text-center">
                    <p className="text-base font-bold text-primary">150 à 200 litres</p>
                  </CardFooter>
                </Card>
              </div>
            </div>
          </div>

          <div className="bg-[#0E6952] mt-6 sm:mt-8 rounded-lg">
            <div className="flex flex-col justify-between gap-6 md:flex-row">
              <div className="w-full p-4 sm:p-6 md:w-1/2">
                <h2 className="text-xl font-bold text-white">Comment repérer une fuite</h2>
                <p className="mt-4 text-base text-white sm:mt-6">
                  Principales causes d’une consommation excessive, les fuites d’eau doivent être
                  traquées. La chasse au gaspillage est ouverte. Pour cela, entretenez régulièrement
                  les canalisations et robinets chez vous afin de prévenir d’éventuelles fuites.
                </p>
              </div>
              <div className="w-full p-4 sm:p-6 md:w-1/2">
                <img src={xrobinet} alt="Leaking faucet" className="w-full h-auto rounded-lg" />
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-8">
            <h2 className="text-xl font-bold text-black">Un moyen efficace de les repérer :</h2>
            <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2 md:grid-cols-3 sm:gap-6 sm:mt-6">
              <div className="flex flex-col items-center">
                <img
                  src={compteur1}
                  alt="Water meter reading at night"
                  className="object-cover w-full h-48 rounded-lg sm:h-64"
                />
                <p className="mt-2 text-base font-bold text-center">
                  Relevez le soir les chiffres inscrits sur votre compteur
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src={machine}
                  alt="Avoiding water use at night"
                  className="object-cover w-full h-48 rounded-lg sm:h-64"
                />
                <p className="mt-2 text-base font-bold text-center">
                  Pendant la nuit, assurez-vous de ne pas consommer d’eau, en évitant de programmer
                  une machine à laver par exemple.
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src={compteur2}
                  alt="Water meter reading in the morning"
                  className="object-cover w-full h-48 rounded-lg sm:h-64"
                />
                <p className="mt-2 text-base font-bold text-center">
                  Le lendemain matin, si vous constatez que les chiffres ont changé, c’est qu’il y a
                  une fuite.
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <h2 className="mt-4 text-base text-center sm:mt-6 text-primary">
            Ruisseau « non domanial », le ru de Gally appartient à ses riverains, jusqu’au milieu de
            son lit. Cela engendre des droits mais aussi des devoirs, à découvrir dans ce petit
            guide pratique.
          </h2>

          <div className="flex flex-col justify-between gap-6 mt-4 md:flex-row sm:mt-6">
            <div className="w-full md:w-1/2">
              <p className="text-base text-black">
                Le Guide du Riverain est un document destiné aux propriétaires ou usagers vivant à
                proximité d’un cours d’eau. Il vise à informer sur les droits, devoirs et bonnes
                pratiques pour préserver les milieux aquatiques. Bien que des guides spécifiques
                existent pour différentes régions, ils partagent des principes communs. Voici un
                résumé des points essentiels :
              </p>
              <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-3 sm:gap-6 sm:mt-3">
                <Card className="bg-secondary/10">
                  <CardContent className="p-4 text-base font-bold text-center sm:p-6 text-primary">
                    Devoirs du riverain
                  </CardContent>
                </Card>
                <Card className="bg-secondary/10">
                  <CardContent className="p-4 text-base font-bold text-center sm:p-6 text-primary">
                    Bonnes pratiques
                  </CardContent>
                </Card>
                <Card className="bg-secondary/10">
                  <CardContent className="p-4 text-base font-bold text-center sm:p-6 text-primary">
                    Réglementation
                  </CardContent>
                </Card>
              </div>
            </div>
            <div className="flex flex-col items-center w-full md:w-1/2">
              <img
                src={guide}
                alt="Guide du riverain document"
                className="w-full h-auto max-w-xs sm:max-w-sm"
              />
              <div className="mt-2 sm:mt-3">
                <Link to="/guide_du_riverain_web.pdf" target="_blank">
                  <Button>Guide du riverain</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GemapiPratique;
